"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/// <summary>
/// Detects and saves if this is a touch screen of a non-mobile device.
/// The only reliable way to detect if this is actually a touch screen, is to catch a touch event.
/// </summary>
var TouchScreenUtil = /** @class */ (function () {
    function TouchScreenUtil() {
    }
    Object.defineProperty(TouchScreenUtil, "HasUserTouchedScreen", {
        /// <summary>
        /// Returns whether or not the user has touched a touch screen.
        /// This can be used to determine if the current connected screen is a touch screen or not.
        /// (Best way found so far, to check an actual connection of a touch screen).
        /// </summary>
        get: function () {
            return TouchScreenUtil.hasUserTouchedScreen;
        },
        enumerable: true,
        configurable: true
    });
    /// <summary>
    /// Starts listening to the TouchStart event to detect the first StartTouch event.
    /// </summary>
    TouchScreenUtil.Init = function () {
        if (document.body !== null && document.body !== undefined) {
            document.body.addEventListener('touchstart', TouchScreenUtil.HandleTouchStart, false);
        }
    };
    /// <summary>
    /// Updates the userHasTouchedScreen variable once a TouchStart event has been detected.
    /// No need to keep listening to the event. Once a touch event has detected, it must be a touch screen.
    /// </summary>
    TouchScreenUtil.HandleTouchStart = function (e) {
        if (TouchScreenUtil.hasUserTouchedScreen) {
            return;
        }
        TouchScreenUtil.hasUserTouchedScreen = true;
        document.body.removeEventListener('touchstart', TouchScreenUtil.HandleTouchStart, false);
    };
    TouchScreenUtil.hasUserTouchedScreen = false;
    return TouchScreenUtil;
}());
exports.TouchScreenUtil = TouchScreenUtil;
//# sourceMappingURL=TouchScreenUtil.js.map